module.exports = __webpack_public_path__ + "img/micheal-relth-little-birdy.4e11759.jpg";